import React, { ReactElement, useEffect, useState } from 'react';
import { Editor, EditorState } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Link, Redirect } from 'react-router-dom';
import draftToHtml from 'draftjs-to-html';
import {
  ContentState,
  EditorState as EditorStates,
  convertToRaw,
} from 'draft-js';
import StaticContentManager from '../../../../services/StaticContentManager';
import { StaticContentInterface } from '../../../../interfaces/StaticContentInterface';
import htmlToDraft from 'html-to-draftjs';
import { ApiErrorHandler } from "../../../../services/api";
import { useAuth } from "../../../../hooks/useAuth";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { Icon } from "leaflet";

export default (): ReactElement => {
   const { logout } = useAuth();
  const [redirect, setRedirect] = useState<boolean>(false);
  const [id, setId] = useState<string>()
  const [name, setName] = useState<string>();
  const [plainText, setPlainText] = useState<string>();
  const [slug, setSlug] = useState<string>();
  const [staticContent, setStaticContent] = useState<StaticContentInterface>();
  const [content, setContent] = useState<string>();
  const [edit, setEdit] = useState<EditorState>();

  const convertHtmlToDraft = () => {
    if (staticContent?.content) {
      const blocksFromHtml = htmlToDraft(staticContent.content);
      const { contentBlocks, entityMap } = blocksFromHtml;
      const contentState = ContentState.createFromBlockArray(
        contentBlocks,
        entityMap
      );
      setEdit(EditorStates.createWithContent(contentState));
    }
  };

  const getStaticContent = async () => {
    if (id) {
      const entity = await StaticContentManager.getOne(id)
      setStaticContent(entity);
      if (entity){
        setContent(entity.content);
        setName(entity.name);
        setSlug(entity.slug);
        setPlainText(entity.plainText)
      }
    }
  };

  const getIdFromUrl = () => {
    const url = window.location.href;
    const regex = new RegExp('seminars/staticContent/editor/(.*)');
    const id = regex.exec(url);
    setId(id ? id[1] : '');
  };

  useEffect(() => {
    (async () => {
      await getIdFromUrl();
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (id) {
        await getStaticContent();
      }
    })();
  }, [id]);

  useEffect(() => {
    (async () => {
      if (staticContent?.content) {
        await convertHtmlToDraft();
      }
    })();
  }, [staticContent?.content]);

  const handleSave = async () => {

    let markup = undefined
    if (edit) {
      const rawContentState = convertToRaw(edit.getCurrentContent());
      markup = draftToHtml(rawContentState);
      setContent(markup);
    }
      if (staticContent && staticContent.id) {
        try{
        await StaticContentManager.update(staticContent.id, { slug, name, content: markup, plainText });
        await setRedirect(true);

        }catch (e){
          ApiErrorHandler(e, {
            onUnauthorizedError: logout,
            onConflictError: () => {
              withReactContent(Swal).fire({
                icon: 'warning',
                title: `Ein statischer Inhalt mit dem Slug "${slug}" existiert bereits`,
                confirmButtonText: 'Ok',
              })
            }
          })
        }
      }else{

        try{
          await StaticContentManager.create( {slug, name, content: markup });
          await setRedirect(true);

        }catch (e){
          ApiErrorHandler(e, {
            onUnauthorizedError: logout,
            onConflictError: () => {
              withReactContent(Swal).fire({
                icon: 'warning',
                title: `Ein statischer Inhalt mit dem Slug "${slug}" existiert bereits`,
                confirmButtonText: 'Ok',
              })
            }
          })
        }
      }
  };

  if (redirect) return <Redirect to={`/seminars/staticContent`} />;

  return (
    <section className="content-header">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
            <h1>{staticContent?.name?staticContent.name:'Neuer statischer Inhalt'}</h1>
          </div>
          <div
            className="col-sm-6"
            style={{
              textAlign: 'right',
            }}
          >
            <Link to={`/seminars/staticContent`}>
              <button type="button" className="btn btn-secondary btn-sm">
                Abbrechen
              </button>
            </Link>
            &nbsp; &nbsp; &nbsp;
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={handleSave}
            >
              Speichern
            </button>
          </div>
        </div>
        <div>
          <div className="form-group">
            <label>Name</label>
            <input
              type="text"
              className="form-control"
              onChange={(e) => setName(e.target.value)}
              value={name}
            />
          </div>


          <div className="form-group">
            <label>Slug</label>
            <input
              type="text"
              className="form-control"
              onChange={(e) => setSlug(e.target.value)}
              value={slug}
            />
          </div>

          <div className="form-group">
            <label>Klartext</label>
            <textarea
              className="form-control"
              onChange={(e) => setPlainText(e.target.value)}
              value={plainText}
            />
          </div>
          <div className="card card-primary">
            <div className="card-body">
              <Editor
                editorState={edit}
                onEditorStateChange={(value) => {
                  setEdit(value);
                }}
                editorStyle={{
                  minHeight: '65vh',
                  borderColor: '#F1F1F1',
                  borderWidth: 1,
                  borderStyle: 'solid',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
